import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../../shared.module';

import { LsInputTextComponent } from './ls-input-text.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  declarations: [LsInputTextComponent],
  exports: [LsInputTextComponent]
})
export class LsInputTextModule {}
